export default {
	radians(deg) {
		return deg * (Math.PI / 180);
	},

	degrees(rad) {
		return rad * (180 / Math.PI);
	},

	locationOffset(location, ang, d) {
		const r = 6378.1;
		const distance = d / 1000;
		const angle = this.radians(ang);
		const lat1 = this.radians(location.lat);
		const lng1 = this.radians(location.lng);

		const lat2 = Math.asin((Math.sin(lat1) * Math.cos(distance / r)) +
			(Math.cos(lat1) * Math.sin(distance / r) * Math.cos(angle)));

		const lng2 = lng1 + Math.atan2(
			Math.sin(angle) * Math.sin(distance / r) * Math.cos(lat1),
			Math.cos(distance / r) - (Math.sin(lat1) * Math.sin(lat2)),
		);

		return {
			lat: this.degrees(lat2),
			lng: this.degrees(lng2),
		};
	},

	distance(locationA, locationB) {
		if ((locationA.lat == locationB.lat) && (locationA.lng == locationB.lng)) return 0;

		const radlat1 = Math.PI * locationA.lat/180;
		const radlat2 = Math.PI * locationB.lat/180;
		const theta = locationA.lng - locationB.lng;
		const radtheta = Math.PI * theta/180;
		let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
		if (dist > 1) dist = 1;
		dist = Math.acos(dist);
		dist = dist * 180/Math.PI;
		dist = dist * 60 * 1.1515;
		dist = dist * 1609.344;

		return dist;
	}
};
